// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".styling-header{background-color:#007a59;height:160px}.imgStyle{width:500px}@media (max-width:600px){.imgStyle{width:auto}}.imgStyleRight{width:300px}@media (max-width:600px){.imgStyleRight{width:250px}}.inner-header{transition:padding .2s cubic-bezier(.4,0,.2,1);border-top:4px solid #007a59;margin-top:35px}.inner-header:after{content:\" \";height:2px;position:absolute;top:0;left:0;right:0}", ""]);
// Exports
exports.locals = {
	"primaryColor": "#0d0078",
	"primaryLightColor": "#1cb9fd",
	"secondaryColor": "#fdba12",
	"accentColor": "#96ff73",
	"textColor": "#333"
};
module.exports = exports;
